import React from 'react';
import { Button, Stack } from '@ovotech/element-v5';
import { TOPUP_COPY_ACTIONS, TopupCopyAction } from './utils/topupCopy';

type Props = {
  actions?: TopupCopyAction[];
};

const BUTTON_STYLES: Record<
  TopupCopyAction,
  { variant?: 'outline'; iconRight: 'new-window' | 'chevron-right' }
> = {
  webchat: { iconRight: 'new-window' },
  call: { variant: 'outline', iconRight: 'chevron-right' },
  manualTopupHelp: { iconRight: 'new-window' },
};

const openAction = (href: string) => {
  if (href.startsWith('tel:')) {
    window.location.assign(href);
    return;
  }
  window.open(href, '_blank', 'noopener');
};

export const TopupActions = ({ actions }: Props) => {
  if (!actions?.length) {
    return null;
  }

  return (
    <Stack spaceBetween={4} orientation="horizontal">
      {actions.map(action => {
        const { label, href } = TOPUP_COPY_ACTIONS[action];
        const { variant, iconRight } = BUTTON_STYLES[action];
        return (
          <Button
            key={action}
            variant={variant}
            iconRight={iconRight}
            onClick={() => openAction(href)}
          >
            {label}
          </Button>
        );
      })}
    </Stack>
  );
};
